import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StringsHelper {
  static getWrappedStringIfExists(text: string, start = "(", end = ")") {
    return text ? (start + text + end) : "";
  }
}
